(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[208],{

/***/ 1369:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pass",
      function () {
        return __webpack_require__(2510);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _locales_en__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7428);
/* harmony import */ var _locales_ru__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7387);






var ApplicationScopeSection = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var t = router.locale === "en" ? _locales_en__WEBPACK_IMPORTED_MODULE_4__.en : _locales_ru__WEBPACK_IMPORTED_MODULE_5__.ru;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: t.applications.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "application-scope",
                children: t.applications.list && t.applications.list.map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "application-scope__item",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "application-scope__img-container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    height: 46,
                                    width: 46,
                                    src: item.src
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "application-scope__title",
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: "sphere-list body-text_gray",
                                        children: item.list.map(function(subItem, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                children: subItem
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ApplicationScopeSection);


/***/ }),

/***/ 2841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _titleSectionSubPage_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6550);
/* harmony import */ var _titleSectionSubPage_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_titleSectionSubPage_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _modalLayout_ModalLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7114);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _locales_en__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7428);
/* harmony import */ var _locales_ru__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7387);









var TitleSectionSubPage = function(param) {
    var firstSection = param.firstSection, title = param.title, description = param.description, boldDescription = param.boldDescription, backgroundUrl = param.backgroundUrl, mobileBackgroundUrl = param.mobileBackgroundUrl;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var t = router.locale === "en" ? _locales_en__WEBPACK_IMPORTED_MODULE_6__.en : _locales_ru__WEBPACK_IMPORTED_MODULE_7__.ru;
    var modal = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_modalLayout_ModalLayout__WEBPACK_IMPORTED_MODULE_4__/* .ModalContext */ .t);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-gray",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_titleSectionSubPage_module_css__WEBPACK_IMPORTED_MODULE_8___default().titleSectionImageContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    layout: "responsive",
                    height: 133,
                    width: 375,
                    src: mobileBackgroundUrl,
                    alt: "background"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_titleSectionSubPage_module_css__WEBPACK_IMPORTED_MODULE_8___default().titleSectionContainer), "section"),
                style: {
                    backgroundImage: "url(".concat(backgroundUrl.src, ")")
                },
                ref: firstSection,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_titleSectionSubPage_module_css__WEBPACK_IMPORTED_MODULE_8___default().textAboutTitleSection),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: (_titleSectionSubPage_module_css__WEBPACK_IMPORTED_MODULE_8___default().title),
                            children: title
                        }),
                        boldDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_titleSectionSubPage_module_css__WEBPACK_IMPORTED_MODULE_8___default().titleDescriptionBold),
                            children: boldDescription
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_titleSectionSubPage_module_css__WEBPACK_IMPORTED_MODULE_8___default().titleDescription),
                            children: description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "button_base",
                            onClick: modal.openFormModal,
                            children: t.btn.getConsultation
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TitleSectionSubPage);


/***/ }),

/***/ 3402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _videoSection_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7738);
/* harmony import */ var _videoSection_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_videoSection_module_css__WEBPACK_IMPORTED_MODULE_3__);




var VideoSection = function(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("section", (_videoSection_module_css__WEBPACK_IMPORTED_MODULE_3___default().section)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_videoSection_module_css__WEBPACK_IMPORTED_MODULE_3___default().videoContainer),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "main-video-container",
                    children: children
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_videoSection_module_css__WEBPACK_IMPORTED_MODULE_3___default().videoDescription),
                    children: title
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoSection);


/***/ }),

/***/ 2510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pass; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Header/Header.tsx + 1 modules
var Header = __webpack_require__(1506);
// EXTERNAL MODULE: ./components/TitleSection/TitleSectionSubPage.tsx
var TitleSectionSubPage = __webpack_require__(2841);
// EXTERNAL MODULE: ./components/VideoSection/VideoSection.tsx
var VideoSection = __webpack_require__(3402);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./styles/pass.module.css
var pass_module = __webpack_require__(7848);
var pass_module_default = /*#__PURE__*/__webpack_require__.n(pass_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/ApplicationScopeSection/ApplicationScopeSection.tsx
var ApplicationScopeSection = __webpack_require__(5124);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(9057);
;// CONCATENATED MODULE: ./public/pass-title-bg.png
/* harmony default export */ var pass_title_bg = ({"src":"/_next/static/media/pass-title-bg.52e7aa20.png","height":503,"width":522,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABE0lEQVR4nAEIAff+AUxhaQD7/wNkUj84mQ778AIiLDMA2eHh/svW02f7/gScAVZIIk3jD0eyUjcxAD0qHf/b9QEA5+3uAfbz6ADS499OAVZXTtYBDhYpNSgt/TUrKwPA1dcA7e3u/RcSDAMgGxvXAWlxcf0OEhICxODwADAcGQAXCv4A4+TmABIPCwAsJib+AX6DgP/s8PEAwt3sADMlJQAUBvkAJRwYAOnw8gAUDg34AXuCff/n7PcAwN/rAG1LRAD49OsADgsG+uzy9AYUCwm4AXJ7dv/i6fcA//8BAFRNSgDo490A5+jgAOzy9ukyJCA5AWhwaf/d6PcAJx0XAC0vMgDl4t/79O/lxJ7Bx2ZgQUDcgQl35BvDdScAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./locales/en.js
var en = __webpack_require__(7428);
// EXTERNAL MODULE: ./locales/ru.js
var ru = __webpack_require__(7387);
// EXTERNAL MODULE: ./components/modalLayout/ModalLayout.tsx + 38 modules
var ModalLayout = __webpack_require__(7114);
;// CONCATENATED MODULE: ./pages/pass.tsx















var Pass = function() {
    var firstSection = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var t = router.locale === "en" ? en.en : ru.ru;
    var modal = (0,react.useContext)(ModalLayout/* ModalContext */.t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                firstSection: firstSection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSectionSubPage/* default */.Z, {
                        title: "Fa\u0441e2Pass",
                        description: t.face2pass.header.subtitle,
                        boldDescription: t.face2pass.header.title,
                        firstSection: firstSection,
                        backgroundUrl: pass_title_bg,
                        mobileBackgroundUrl: "/pass-title-bg-sm.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSection/* default */.Z, {
                        title: t.face2pass.videoSection.description,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            className: "main-video",
                            src: "https://www.youtube-nocookie.com/embed/KmRE-YiN3ec?modestbranding=1",
                            title: "YouTube video player",
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                            allowFullScreen: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: classnames_default()("section", (pass_module_default()).advantageSection),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: (pass_module_default()).advantages,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (pass_module_default()).advantagesInfoContainer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (pass_module_default()).advantagesInfo,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classnames_default()("section-logo-text_white", (pass_module_default())["section-logo-text_white"]),
                                                    children: [
                                                        "Face",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "services__section-logo-container",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                width: 32,
                                                                height: 32,
                                                                src: "/face2greenLogo.svg"
                                                            })
                                                        }),
                                                        "Pass"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "terminal-list__title",
                                                    children: t.face2pass.advantageSection.list[0].title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (pass_module_default()).advantagesDescription,
                                                    children: t.face2pass.advantageSection.list[0].text
                                                })
                                            ]
                                        })
                                    })
                                }),
                                t.face2pass.advantageSection.list && t.face2pass.advantageSection.list.slice(1, t.face2pass.advantageSection.list.length).map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (pass_module_default()).advantagesInfoContainer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (pass_module_default()).advantagesInfo,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "services__title",
                                                    children: item.title
                                                })
                                            })
                                        })
                                    }, index);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: classnames_default()("section-white", (pass_module_default()).applicationScopeSection),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationScopeSection/* default */.Z, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: classnames_default()("section-after-white section-sm", (pass_module_default()).sectionSM),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "section-sm__inner-wrapper",
                                children: t.face2pass.terminal.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: classnames_default()("terminal-list", (pass_module_default()).terminalList),
                                children: t.face2pass.terminal.list && t.face2pass.terminal.list.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "terminal-list__item",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "terminal-item__container",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "terminal-list__title",
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "body-text_white",
                                                    children: item.text
                                                })
                                            ]
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: classnames_default()("terminal-description"),
                                children: t.face2pass.terminal.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                style: {
                                    margin: "10px auto"
                                },
                                className: "button_base",
                                onClick: function() {
                                    return modal.openFormModal(true);
                                },
                                children: t.btn.consultationCost
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-center",
                                children: t.face2pass.ControlTheSystem.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (pass_module_default()).capabilitiesDescription,
                                children: t.face2pass.ControlTheSystem.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (pass_module_default()).capabilities,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: (pass_module_default()).capabilityList,
                                        children: t.face2pass.ControlTheSystem.list && t.face2pass.ControlTheSystem.list.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: (pass_module_default()).capabilitiesItem,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (pass_module_default()).capabilitiesItemImage,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            height: 32,
                                                            width: 32,
                                                            src: item.src
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "body-text",
                                                        children: item.text
                                                    })
                                                ]
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (pass_module_default()).capabilityImage,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            width: 568,
                                            height: 483,
                                            src: "/capabilityImage.png"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var pass = (Pass);


/***/ }),

/***/ 6550:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"titleSectionSubPage_title__bKKGY","titleDescriptionBold":"titleSectionSubPage_titleDescriptionBold__T0FGQ","titleDescription":"titleSectionSubPage_titleDescription__n0f4_","titleSectionContainer":"titleSectionSubPage_titleSectionContainer__0OZYC","titleSectionImageContainer":"titleSectionSubPage_titleSectionImageContainer__7ThT4","textAboutTitleSection":"titleSectionSubPage_textAboutTitleSection__p3IKq","textAboutTitleSectionLong":"titleSectionSubPage_textAboutTitleSectionLong__sKana","aboutList":"titleSectionSubPage_aboutList__4_9uZ"};

/***/ }),

/***/ 7738:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"videoSection_section__fdqJe","videoContainer":"videoSection_videoContainer__5giTB","videoDescription":"videoSection_videoDescription__zBsDh"};

/***/ }),

/***/ 7848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"advantages":"pass_advantages__XqVUr","advantagesInfoContainer":"pass_advantagesInfoContainer__GQefG","section-logo-text_white":"pass_section-logo-text_white___iTjR","advantagesDescription":"pass_advantagesDescription__uMTAe","advantagesInfo":"pass_advantagesInfo__6iXZ3","applicationScopeSection":"pass_applicationScopeSection__BbBve","terminalList":"pass_terminalList__ZekmQ","connectingCost":"pass_connectingCost__u73Wv","costCalculator":"pass_costCalculator__tK_2A","costResult":"pass_costResult__3lFwF","constDescription":"pass_constDescription__rHL97","capabilitiesDescription":"pass_capabilitiesDescription__1M_EJ","capabilities":"pass_capabilities__soR4b","capabilityImage":"pass_capabilityImage__JCkGO","capabilityList":"pass_capabilityList__51jer","capabilitiesItem":"pass_capabilitiesItem__DgBul","capabilitiesItemImage":"pass_capabilitiesItemImage__ah_I8","terminal-list__title":"pass_terminal-list__title__heiWG","costPriceContainer":"pass_costPriceContainer__wIXR0","costInfo":"pass_costInfo__3F_JA","advantageSection":"pass_advantageSection__OjKk6","sectionSM":"pass_sectionSM__Ri2F7"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [645,61,510,722,924,774,888,179], function() { return __webpack_exec__(1369); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);